import { DatePicker, Select, Table } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getAssignmentsByUserId } from "../../redux/rtk/features/assets/assetsSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

const { Option } = Select;

function CustomTable({ list = [], loading, currentPage, pageSize }) {
  const [columnsToShow, setColumnsToShow] = useState([]);
  const { RangePicker } = DatePicker;
  const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));
  const [filteredList, setFilteredList] = useState([]);
  const assets = useSelector((state) => state.asset.assetsByUser || []); // Always an array

  const columns = [
    {
		title: "S.No",
		key: "serial",
		render: (_, record, index) => index + 1,
	  },
    {
      title: "Asset Type",
      key: "assetsTypeName",
      render: (record) => {
        console.log("Record:", record); // Log each record to check the data structure
        return record?.assets?.assetstype?.assetsTypeName || "N/A";
      },
    },    
    {
      title: "Asset Name",
      dataIndex: "assetName",
      key: "assetName",
    },
    {
      title: "Asset Code 1 Name",
      dataIndex: "assetCode1Name",
      key: "assetCode1Name",
    },
    {
      title: "Asset Code 1",
      dataIndex: "assetCode1",
      key: "assetCode1",
    },
    {
      title: "Asset Code 2 Name",
      dataIndex: "assetCode2Name",
      key: "assetCode2Name",
    },
    {
      title: "Asset Code 2",
      dataIndex: "assetCode2",
      key: "assetCode2",
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  useEffect(() => {
    if (list.length > 0) {
      const filtered = list.filter((item) => {
        const expDate = moment(item.assignedDate).format("YYYY-MM-DD");
        const matchesDateRange = expDate >= fromDate && expDate <= toDate;
        return matchesDateRange;
      });
      setFilteredList(filtered);
    } else {
      setFilteredList([]);
    }
  }, [fromDate, toDate, list]);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

  return (
    <div className="ant-card p-4 rounded mt-5">
      <div className="flex my-2 justify-between">
        <h4 className="text-2xl mb-2">My Asset</h4>
        <div>
          {/* <RangePicker
            defaultValue={[moment().startOf("month"), moment().endOf("month")]}
            onChange={(dates) => {
              if (dates) {
                setFromDate(moment(dates[0]).format("YYYY-MM-DD"));
                setToDate(moment(dates[1]).format("YYYY-MM-DD"));
              }
            }}
          /> */}
        </div>
        <div>
          <CsvLinkBtn>
            <CSVLink
              data={filteredList}
              className="btn btn-dark btn-sm"
              style={{ marginTop: "5px" }}
              filename="asset_assignments"
            >
              Download CSV
            </CSVLink>
          </CsvLinkBtn>
        </div>
      </div>
      <ColVisibilityDropdown
        options={columns}
        columns={columns}
        columnsToShowHandler={columnsToShowHandler}
      />
      <Table
        className="text-center"
        scroll={{ x: true }}
        loading={loading}
        columns={columnsToShow}
        dataSource={filteredList.map((item) => ({
          ...item,
          key: item.id,
          serial: item.id,
          ...item.assets,
        }))}
      />
    </div>
  );
}

const MyAssets = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const assets = useSelector((state) => state.asset.assetsByUser || []); // Ensure `assets` is always an array
  const loading = useSelector((state) => state.asset.loading);

  useEffect(() => {
    dispatch(getAssignmentsByUserId(id));
  }, [dispatch, id]);

  return (
    <UserPrivateComponent permission={"readSingle-leaveApplication"}>
      <div className="card">
        <div className="card-body">
          <CustomTable list={assets} loading={loading} currentPage={1} pageSize={10} />
        </div>
      </div>
    </UserPrivateComponent>
  );
};

export default MyAssets;